export const calc = (ticket, serviceAvailability, date, startTime) => {
    if (
        ticket.type === 'annual' ||
        ticket.type === 'autumn' ||
        ticket.type === 'spring' ||
        ticket.type === 'summer' ||
        !date
    ) {
        return null;
    }

    if (ticket.type === 'single') {
        if (!startTime) {
            return null;
        }
        const calendarDate = date.format('YYYYMMDD') + startTime.toUpperCase();
        if (serviceAvailability && calendarDate in serviceAvailability) {
            return serviceAvailability[calendarDate];
        }
    }

    if (ticket.type === 'return') {
        const calendarAMDate = `${date.format('YYYYMMDD')}AM`;
        const calendarPMDate = `${date.format('YYYYMMDD')}PM`;
        const amAvailability = serviceAvailability[calendarAMDate];
        const pmAvailability = serviceAvailability[calendarPMDate];

        return amAvailability > pmAvailability
            ? pmAvailability
            : amAvailability;
    }

    if (ticket.type === 'week') {
        const currentDate = date.clone().startOf('day');
        const oneWeek = date
            .clone()
            .endOf('day')
            .add(6, 'days');

        const dates = [];

        while (currentDate <= oneWeek) {
            dates.push(currentDate.format('YYYYMMDDA'));
            currentDate.add(12, 'hours');
        }

        let lowestAvailability = null;

        dates.forEach(day => {
            lowestAvailability =
                lowestAvailability === null ||
                lowestAvailability > serviceAvailability[day]
                    ? serviceAvailability[day]
                    : lowestAvailability;
        });

        return lowestAvailability;
    }

    if (ticket.type === '4_week') {
        const currentDate = date.clone().startOf('day');
        const fourWeek = date
            .clone()
            .endOf('day')
            .add(4, 'weeks')
            .subtract(1, 'day');

        const dates = [];

        while (currentDate <= fourWeek) {
            dates.push(currentDate.format('YYYYMMDDA'));
            currentDate.add(12, 'hours');
        }

        let lowestAvailability = null;

        dates.forEach(day => {
            lowestAvailability =
                lowestAvailability === null ||
                lowestAvailability > serviceAvailability[day]
                    ? serviceAvailability[day]
                    : lowestAvailability;
        });

        return lowestAvailability;
    }

    return 0;
};

export const isDateAvailable = (
    ticket,
    serviceAvailability,
    date,
    startTime
) => {
    if (ticket.type === 'single') {
        if (startTime !== 'am' && startTime !== 'pm') {
            return false;
        }
        const calendarDate = date.format('YYYYMMDD') + startTime.toUpperCase();
        if (
            serviceAvailability &&
            calendarDate in serviceAvailability &&
            serviceAvailability[calendarDate] <= 0
        ) {
            return false;
        }
        return true;
    }

    if (ticket.type === 'return') {
        const calendarAMDate = `${date.format('YYYYMMDD')}AM`;
        const calendarPMDate = `${date.format('YYYYMMDD')}PM`;
        const amAvailability = serviceAvailability[calendarAMDate];
        const pmAvailability = serviceAvailability[calendarPMDate];

        const lowestAvailability =
            amAvailability > pmAvailability ? pmAvailability : amAvailability;
        return lowestAvailability > 0;
    }

    if (ticket.type === 'week') {
        const currentDate = date.clone().startOf('day');
        const oneWeek = date
            .clone()
            .endOf('day')
            .add(6, 'days');

        const dates = [];

        while (currentDate <= oneWeek) {
            dates.push(currentDate.format('YYYYMMDDA'));
            currentDate.add(12, 'hours');
        }

        let lowestAvailability = null;

        dates.forEach(day => {
            lowestAvailability =
                lowestAvailability === null ||
                lowestAvailability > serviceAvailability[day]
                    ? serviceAvailability[day]
                    : lowestAvailability;
        });

        return lowestAvailability > 0;
    }

    if (ticket.type === '4_week') {
        const currentDate = date.clone().startOf('day');
        const fourWeeks = date
            .clone()
            .endOf('day')
            .add(4, 'weeks')
            .subtract(1, 'day');

        const dates = [];

        while (currentDate <= fourWeeks) {
            dates.push(currentDate.format('YYYYMMDDA'));
            currentDate.add(12, 'hours');
        }

        let lowestAvailability = null;

        dates.forEach(day => {
            lowestAvailability =
                lowestAvailability === null ||
                lowestAvailability > serviceAvailability[day]
                    ? serviceAvailability[day]
                    : lowestAvailability;
        });

        return lowestAvailability > 0;
    }

    return false;
};

export const isUnavailableFn = (ticket, serviceAvailability, passenger) => {
    if (
        ticket.type === 'single' ||
        ticket.type === 'return' ||
        ticket.type === 'week' ||
        ticket.type === '4_week'
    ) {
        const { startTime } = passenger;
        return date => {
            return !isDateAvailable(
                ticket,
                serviceAvailability,
                date,
                startTime
            );
        };
    }

    return false;
};

export const isAnyAvailable = (ticket, serviceAvailability, today) => {
    if (
        ticket.type === 'annual' ||
        ticket.type === 'autumn' ||
        ticket.type === 'spring' ||
        ticket.type === 'summer' ||
        ticket.type === 'flexi'
    ) {
        return true;
    }

    let hasAvailability = false;
    let endDate;
    const currentDate = today.clone().startOf('day');

    if (ticket.type === 'single') {
        endDate = today
            .clone()
            .endOf('day')
            .add(7, 'days');

        while (currentDate <= endDate) {
            hasAvailability =
                hasAvailability === true ||
                isDateAvailable(
                    ticket,
                    serviceAvailability,
                    currentDate,
                    currentDate.format('a')
                );
            currentDate.add(12, 'hours');
        }

        return hasAvailability;
    }

    if (ticket.type === 'return') {
        endDate = today
            .clone()
            .endOf('day')
            .add(7, 'days');

        while (currentDate <= endDate) {
            hasAvailability =
                hasAvailability === true ||
                isDateAvailable(
                    ticket,
                    serviceAvailability,
                    currentDate,
                    currentDate.format('a')
                );
            currentDate.add(1, 'day');
        }

        return hasAvailability;
    }

    if (ticket.type === 'week') {
        endDate = today
            .clone()
            .endOf('day')
            .add(7, 'days');

        while (currentDate <= endDate) {
            hasAvailability =
                hasAvailability === true ||
                isDateAvailable(
                    ticket,
                    serviceAvailability,
                    currentDate,
                    currentDate.format('a')
                );
            currentDate.add(1, 'day');
        }

        return hasAvailability;
    }

    if (ticket.type === '4_week') {
        endDate = today
            .clone()
            .endOf('day')
            .add(7, 'days');

        while (currentDate <= endDate) {
            hasAvailability =
                hasAvailability === true ||
                isDateAvailable(
                    ticket,
                    serviceAvailability,
                    currentDate,
                    currentDate.format('a')
                );
            currentDate.add(1, 'day');
        }

        return hasAvailability;
    }

    return false;
};
